import React from "react";
import { RollingFloorLoader } from "@coverme/elements";

export const LoadingBar = RollingFloorLoader;
